import { useEffect } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Overview from "./components/Overview";
import GraphMap from "./components/GraphMap";
import PersonSection from "./components/PersonSection";
import Relations from "./components/Relations";
import Timeline from "./components/Timeline";
import Faq from "./components/Faq";
import Footer from "./components/Footer";
import { faqs } from "../../mocks/gossip";

export default function Home() {
  useEffect(() => {
    document.title = "吃瓜门人物关系与当事人关联图谱全解析 | 吃瓜门图谱";
    const meta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        el.name = name;
        document.head.appendChild(el);
      }
      el.content = content;
    };
    meta(
      "description",
      "吃瓜门事件人物关系图谱：梳理吃瓜门谁是谁、核心当事人与相关关联方之间的复杂关系网络，一张图看懂吃瓜门人物关系与事件脉络。"
    );
    meta("keywords", "吃瓜门,吃瓜门人物关系,吃瓜门谁是谁,吃瓜门相关人物,吃瓜门当事人,吃瓜门关联方");
  }, []);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "WebSite",
                name: "吃瓜门图谱",
                inLanguage: "zh-CN",
                description: "吃瓜门人物关系与当事人关联图谱全解析",
              },
              {
                "@type": "WebPage",
                name: "吃瓜门人物关系与当事人关联图谱全解析",
                inLanguage: "zh-CN",
              },
              {
                "@type": "FAQPage",
                mainEntity: faqs.map((f) => ({
                  "@type": "Question",
                  name: f.q,
                  acceptedAnswer: { "@type": "Answer", text: f.a },
                })),
              },
            ],
          }),
        }}
      />

      <Navbar />
      <main>
        <Hero />
        <Overview />
        <section id="graph" className="mx-auto w-full max-w-6xl px-4 py-16 md:px-6 md:py-20">
          <div className="mx-auto max-w-2xl text-center">
            <p className="inline-flex items-center gap-2 text-sm font-semibold tracking-wide text-[#b4372a]">
              <span className="h-px w-6 bg-[#b4372a]"></span>人物关系图谱<span className="h-px w-6 bg-[#b4372a]"></span>
            </p>
            <h2 className="mt-3 font-serif-sc text-3xl font-black text-[#2a2320] md:text-4xl">
              点击人物，只看他与谁的连线
            </h2>
            <p className="mt-4 leading-relaxed text-[#5a5049]">
              任选下方某个人物或关联方，即可聚焦其直接相连的关系；也可用图例按关系类型筛选，观察不同层面的网络分布。
            </p>
          </div>
          <div className="mt-10 rounded-lg border border-[#eadccb] bg-[#fbf6ef]/70 p-4 md:p-6">
            <GraphMap />
          </div>
        </section>
        <PersonSection />
        <Relations />
        <Timeline />
        <Faq />
      </main>
      <Footer />
    </>
  );
}